import React, {Component} from "react";
import { inject, observer } from "mobx-react";
import { reaction, observable, toJS } from "mobx";
import DataWrapper from '../../principal/containers/DataWrapper';
import {Tabela} from "../../comum/components/Tabela";
import {TabelaFluxo} from "../../comum/components/TabelaFluxo";
import ContratacoesVigentesStore from "../stores/ContratacoesVigentesStore";
import {
    formatarDataISO8601, statusSolicitacaoFormatter, motivoContratacaoFormatter, ordenarData,
    slaFormatter, ordenarSLA, mudarDiasAlerta, nullable, formatarNomeProduto
} from "../../../utils/formatar";
import SolicitacoesAndamentoStore from "../stores/SolicitacoesAndamentoStore";
import {sortAlphaNum} from "../../../utils/ordenar";
import ParametrosGeraisStore from "../../administracao/stores/ParametrosGeraisStore";

@inject("store")
@DataWrapper
@observer
export class SolicitacoesAndamento extends Component {
    constructor(props) {
        super(props);
        this.appStore                  = this.props.store.appStore;
        this.tituloPaginaStore         = this.props.store.tituloPaginaStore;
        this.modalStore                = this.props.store.modalStore;
        this.loginStore                = this.props.store.loginStore;
        /* Selecionar Controller */
        this.controller                = new SolicitacoesAndamentoStore();
        this.parametrosGeraisStore = new ParametrosGeraisStore();
    }

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("Solicitações em andamento");

        this.controller.carregarLista();
        this.parametrosGeraisStore.carregarLista();

        this.tituloPaginaStore.setBotoesMobile([
            {
                label: "Ordenar",
                icone: "sort",
                acao: () => this.modalStore.toggleModal('ordenar')
            }
        ]);
    }

    obterTituloMobile = (objeto) => {
        // return  "#" + objeto.idSolicitacaoExibicao + " - " + objeto.cargo + " para " + objeto.nomeProduto;
        return  (objeto.idSolicitacaoExibicao != null ? "#" + objeto.idSolicitacaoExibicao : "") + (objeto.cargo != null ? " - " + objeto.cargo : "") + (objeto.nomeProduto != null ? " para " + objeto.nomeProduto : "");
    };

    obterConteudoMobile = (objeto) => {
        return (
            <div>
                { "SLA: "}<div  style={{display: "inline-block"}}>{slaFormatter(objeto.sla, objeto)}</div><br/>
                { "Fluxo: " + nullable(this.controller.fluxoFormatter(objeto.nomeFluxo))}<br/>
                { "Tarefa atual: " + nullable(objeto.nomeTarefa)}<br/>
                { "Responsável: " + nullable(objeto.nomeResponsavel)}<br/>
                { "Prazo: " + nullable(objeto.prazo)}<br/>
                { "Gestor: " + nullable(objeto.nomeGestor)}<br/>
                { "Motivo de contratação: " + nullable(motivoContratacaoFormatter(objeto.motivoContratacao))}<br/>
                { "Justificativa: " + nullable(objeto.justificativa)}<br/>
                { "Data de início: " + nullable(objeto.dataInicio)}<br/>
                { "Data de término: " + nullable(objeto.dataFim)}
            </div>
        )
    };

    render() {
        mudarDiasAlerta(this.parametrosGeraisStore.parametros.slaGrlTmpAvaliarResponder)
        const COLUNAS = [
            {
                field: "idSolicitacaoExibicao",
                label: "#",
                funcaoOrdenacao: sortAlphaNum.bind("idSolicitacaoExibicao")
            },{
                field: "nomeFluxo",
                label: "Fluxo",
                dataFormat: this.controller.fluxoFormatter
            },{
                field: "nomeTarefa",
                label: "Tarefa atual",
            },{
                field: "nomeResponsavel",
                label: "Responsável",
            },{
                field: "prazo",
                label: "Prazo",
                funcaoOrdenacao: ordenarData.bind("prazo"),
            },{
                field: "sla",
                label: "SLA",
                dataFormat: slaFormatter,
                funcaoOrdenacao: ordenarSLA.bind("prazo"),
            },{
                field: "nomeGestor",
                label: "Gestor"
            },{
                field: "cargo",
                label: "Cargo"
            },{
                field: "motivoContratacao",
                label: "Motivo de contratação",
                dataFormat: motivoContratacaoFormatter,
            },{
                field: "justificativa",
                label: "Justificativa"
            },{
                field: "nomeProduto",
                label: "Projeto/centro de resultado/finalidade",
                dataFormat: formatarNomeProduto
            },{
                field: "dataInicio",
                label: "Data de início",
                funcaoOrdenacao: ordenarData.bind("dataInicio")
            },{
                field: "dataFim",
                label: "Data de término",
                funcaoOrdenacao: ordenarData.bind("dataFim")
            }
        ];

        let acoesItens = [];
        let acoesMultiplas = [];
        if(this.loginStore.isPerfilAdministradorLogado || this.loginStore.podeSolicitarMOT) {
            acoesItens = ["visualizarAndamento", "clonar"];
            acoesMultiplas = ["cancelar"];
        } else {
            acoesItens = ["visualizarAndamento"];
            acoesMultiplas = [""];
        }

        return (
            <div>
                <div className="form-wrapper">
                    <div className={this.appStore.width > 768 ? "content-panel" : ""}>
                        <TabelaFluxo
                            keyField={"idSolicitacaoExibicao"}
                            nomeFluxo={'Solicitação'}
                            parametroVisualizar={"idSolicitacaoExibicao"}
                            parametroClonar={'idSolicitacao'}
                            parametroFalha={'idSolicitacaoBpm'}
                            temBusca={true}
                            habilitarSelecaoMultipla={true}
                            listaItens={toJS(this.controller.solicitacoesAndamentoLista)}
                            colunas={COLUNAS}
                            //acoesMultiplas={this.loginStore.checkPermission("administrador") ? ["migrarBpm"] : []}
                            acoesMultiplas={acoesMultiplas}
                            acoesItens={acoesItens}
                            tituloMobile={(row) => this.obterTituloMobile(row)}
                            conteudoMobile={(row) => this.obterConteudoMobile(row)}
                            onChange={(value) => this.controller.setLista(value)}
                            onCardClick={this.props.onCardClick}
                            loading={this.controller.loading}
                            reload={() => this.controller.carregarLista()}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

